import { Lot } from '../../../infrastructure/shared/classes/lot';
import {Role} from '../../../identite/shared/classes/role';
import {FactureDetailNormalize} from './facture-detail-normalize';
import {Batiment} from '../../../infrastructure/shared/classes/batiment';
import {Banques} from "../../../identite/shared/classes/banques";
import {Document} from "../../../document/shared/classes/document";
import { FactureClientLots } from './facture-client_lots';
import { CoproprieteDestinataire } from '../../../identite/shared/classes/coproprieteDestinataire';

export class FactureNormalize {
    factureType: string;

    id: string = null;
    lot_id: string = null;
    exr_id: string;
    trs_id: string;
    copropriete_destinataire_id: string;
    cfo_id: string;
    dvc_id: string;
    montant_ttc: number;
    montant_ht: number;
    numero_interne: string;
    numero_honoraire: string;
    reference_interne: string;
    reference_externe: string;
    code_journal: string;
    libelle_facture: string;
    suppression: null;
    honoraire_syndic: null;
    date_facture: Date;
    date_echeance: Date;
    date_piece: Date;
    date_comptabilisation: Date;
    date_metier: Date;
    solde: string;
    role: Role  = new Role();
    lot: Lot    = new Lot();
    emetteur: Role  = new Role();
    destinataire?: Role  = new Role();
    copropriete_destinataire?: CoproprieteDestinataire  = new CoproprieteDestinataire();

    details: FactureDetailNormalize[];
    batiment: Batiment;
    banque: Banques;
    documents: Document[] = [];

    batiment_id: string;
    remise_montant: number = null;
    remise_type: string = null;
    remarque: string = null;

    y_15_id: string = null;

    banque_id: string;
    facture_client_lots: FactureClientLots[] = [];

    constructor(init?: Partial<FactureNormalize>) {
        Object.assign(this, init);
    }

    isFromY15(): boolean {
        return !!(this.y_15_id && +this.y_15_id > 0);
    }

    isFromSoftMetier(): boolean {
        return this.isFromY15();
    }
}
